var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBuilding = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 20 20"
}), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeWidth: 1.25,
  clipPath: "url(#clip0_3816_60115)"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M16.875 3.125v16.25M3.125 3.125h13.75M3.125 19.375V3.125M16.875 19.375H3.125M16.875 3.125H3.125l1.25-2.5h11.25zM.625 19.375h18.75M11.875 17.5a1.875 1.875 0 1 0-3.75 0v1.875h3.75z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.25 5.938a.312.312 0 1 1 0-.625M6.25 5.938a.312.312 0 1 0 0-.625M10 5.938a.312.312 0 1 1 0-.625M10 5.938a.313.313 0 1 0 0-.625M13.75 5.938a.313.313 0 1 1 0-.625M13.75 5.938a.313.313 0 1 0 0-.625M6.25 9.688a.312.312 0 1 1 0-.626M6.25 9.688a.312.312 0 1 0 0-.626M10 9.688a.312.312 0 1 1 0-.626M10 9.688a.313.313 0 1 0 0-.626M13.75 9.688a.313.313 0 1 1 0-.626M13.75 9.688a.313.313 0 1 0 0-.626M6.25 13.438a.312.312 0 1 1 0-.626M6.25 13.438a.312.312 0 1 0 0-.626M10 13.438a.312.312 0 1 1 0-.626M10 13.438a.313.313 0 1 0 0-.626M13.75 13.438a.313.313 0 1 1 0-.626M13.75 13.438a.313.313 0 1 0 0-.626"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_3816_60115"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export { SvgBuilding as ReactComponent };